export const TOGGLE_SELECTION = 'TOGGLE_SELECTION';
export const RESET_SELECTION = 'RESET_SELECTION';
export const INITIALIZE_SELECT = 'INITIALIZE_SELECT';
export const DESTROY_SELECT = 'DESTROY_SELECT';
